export const en = {
  header: {
    tools: "tools",
    dev_tools_short: "dev tools",
    contact: "contact",
  },
  content: {
    who_I_am: "who I am",
    who_I_amcontent:
      "Reliable work partner, adaptable to any type of project, eager to learn and improve every day.",
    biography: "biography",
    contact_me: "contact me",
    service: "service",
    services: "services",
    year: "year",
    years: "years",
    years_of_experience: "years of experience",
    projects: "projects",
  },
  footer: {},
  general: {
    language: "language",
  },
};
